import styled from 'styled-components';
import { layout } from 'styled-system';

export enum CardLayout {
	VERTICAL = 'vertical',
	HORIZONTAL = 'horizontal'
}

interface Props {
	cardLayout?: CardLayout;
	cardWrap?: boolean;
	overflow?: string;
	biggerBorderRadius?: boolean;
	noBackground?: boolean;
	alignItemsCenter?: boolean;
}

/**
 * `Card` is the wrapper component.
 * It doesn't do much by itself but should be used in conjunction with
 * other blocks.
 *
 * See the implementation of `HorizontalCard` and `VerticalCard`for examples.
 */
const Card = styled.div<Props>`
	display: flex;
	flex-wrap: ${({ cardWrap }) => (cardWrap ? 'wrap' : 'nowrap')};
	flex-direction: ${({ cardLayout = CardLayout.VERTICAL }) => (cardLayout === 'horizontal' ? 'row' : 'column')};
	border-radius: ${({ biggerBorderRadius }) => (biggerBorderRadius ? '12px' : '3px')};
	height: 100%;
	width: 100%;
	position: relative;
	background: ${({ noBackground }) => (noBackground ? 'none' : 'var(--main-surface-1)')};
	${layout}
`;

export default Card;
